const { type, map } = require("jquery")

window.MapDiv = class {
    constructor(map_id) {
        this.map_id     = map_id
        this.csrf_token = {'X-CSRF-TOKEN': document.getElementById('csrf_token').getAttribute('content')}
    }

    addSpots(spots, is_draggable = false, enabled_spot_modal = true, requested_spot_id = null) {
        // Clear markers.
        this.map_id.eachLayer(layer => {
            if(layer instanceof L.Marker){
                markers.clearLayers()
            }
        })

        // Create cluster group.
        window.markers = L.markerClusterGroup({
                showCoverageOnHover: false,
            })

        spots.forEach(spot => {
            let marker = L.marker([spot.lat, spot.lng], {
                icon:      this.getIcon('inox'),
                draggable: is_draggable,
                title:     spot.title
            })

            // Add marker to cluster group.
            markers.addLayer(marker)

            if (enabled_spot_modal) {
                marker.on("click", () => {
                    this.showSpotModal(marker, spot.id)
                })

                if (requested_spot_id == spot.id) {
                    this.showSpotModal(marker, spot.id)
                }
            }

            if (is_draggable) {
                marker.on("dragend", (e) => {
                    let marker   = e.target
                    let position = marker.getLatLng()
                    Livewire.emit('setLatLng', position)
                    this.map_id.panTo(new L.LatLng(position.lat, position.lng))
                })
            }
        })

        // Add cluster group to map.
        this.map_id.addLayer(markers)
    }

    addCalendarSpots(calendarSpots, requested_coordinates) {
        window.calendarMarkers = L.markerClusterGroup({
            showCoverageOnHover: false,
        })

        calendarSpots.forEach(calendarSpot => {
            // console.log(calendarSpot.coordinates)
            let marker = L.marker([calendarSpot.coordinates.lat, calendarSpot.coordinates.lng], {
                icon:      this.getIcon('trophy'),
                title:     'Calendar Spot'
            })

            calendarMarkers.addLayer(marker)

            if (requested_coordinates == calendarSpot.coordinates.lat + "," + calendarSpot.coordinates.lng) {
                this.showCalendarModal(marker, calendarSpot.coordinates)
            }

            marker.on("click", () => {
                this.showCalendarModal(marker, calendarSpot.coordinates)
            })
        })

        // Add cluster group to map.
        this.map_id.addLayer(calendarMarkers)
    }

    getIcon(variant) {
        switch (variant) {
            case 'inox':
                image_src = '/images/markers/marker-white-inox.png'
                break;
            case 'trophy':
                image_src = '/images/markers/marker-calendar-trophy.png'
                break;
            default:
                image_src = '/images/markers/marker-white-inox.png'
                break;
        }
        let icon = L.icon({
            iconUrl:     image_src,
            iconSize:    [30, 39],
            iconAnchor:  [15, 39],
            popupAnchor: [0, -39]
        })
        return icon
    }

    showSpotModal(marker, spot_id) {
        $.ajax({
            headers: this.csrf_token,
            url:     '/spot/get-modal-content',
            method:  'post',
            data:    {spot_id: spot_id},
            beforeSend: () => {
                this.map_id.setView(marker.getLatLng())
            },
            success: (result) => {
                this.#createModal(result.html, '?spot=' + spot_id)
            }
        })
    }

    showCalendarModal(marker, coordinates) {
        $.ajax({
            headers: this.csrf_token,
            url:     '/calendar/get-modal-content',
            method:  'post',
            data:    {coordinates: coordinates},
            beforeSend: () => {
                this.map_id.setView(marker.getLatLng())
            },
            success: (result) => {
                this.#createModal(result.html, '?calendar-spot=' + coordinates.lat + ',' + coordinates.lng)
            }
        })
    }

    showSearchLocationModal() {
        $.ajax({
            headers: this.csrf_token,
            url:     '/search/get-modal-content',
            method:  'post',
            success: (result) => {
                this.#createModal(result.html, '?search')

                $('#modal').on('shown.bs.modal', function(e) {
                    $('#search-input').focus()
                })
            }
        })
    }

    #createModal(html, dataUrl) {
        $('#modal')
        .attr('data-url', dataUrl)
        .empty().append(html)
        let modal = new bootstrap.Modal('#modal')
        modal.show()
        Livewire.rescan()
    }
}
